import { render, staticRenderFns } from "./FqaModal.vue?vue&type=template&id=8638dda4&"
import script from "./FqaModal.vue?vue&type=script&lang=js&"
export * from "./FqaModal.vue?vue&type=script&lang=js&"
import style0 from "./FqaModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports